module.exports = __webpack_public_path__ + "media/images/icons/outlined/up-circle-edab824514e567073b99ec9e9788a88c.svg";